import api from './api';

export const getFields = async () => {
  const { data } = await api.get('/fields');
  return data;
};

export const createField = async (name, field_type, category, measurement_unit, per_variant) => {
  const { data } = await api.post('/fields', { name, field_type, category, measurement_unit, per_variant });
  return data;
};

export const updateField = async (id, updates) => {
  const { data } = await api.put(`/fields/${id}`, updates);
  return data;
};

export const deleteField = async (id) => {
  const { data } = await api.delete(`/fields/${id}`);
  return data;
};

export const updateFieldMappings = async (id, mappings) => {
  const { data } = await api.put(`/fields/${id}/mappings`, { mappings });
  return data;
};

export const copyStoreMappings = async (source_store_id, target_store_id) => {
  const { data } = await api.post('/fields/copy-store-mappings', { source_store_id, target_store_id });
  return data;
};

export const bulkDeleteFields = async (fieldIds) => {
  const { data } = await api.delete('/fields/bulk', { data: { field_ids: fieldIds } });
  return data;
};

export const bulkUpdateFieldCategory = async (fieldIds, category) => {
  const { data } = await api.put('/fields/bulk-category', { field_ids: fieldIds, category });
  return data;
};

export const pushFieldDefinitions = async (storeIds = []) => {
  const { data } = await api.post('/fields/push-definitions', { store_ids: storeIds });
  return data;
};

export const deleteFieldDefinitions = async (storeIds = [], deleteAssociatedValues = false) => {
  const { data } = await api.post('/fields/delete-definitions', {
    store_ids: storeIds,
    delete_associated_values: deleteAssociatedValues,
  });
  return data;
};
